export default __webpack_public_path__ + "static/media/Anubhav_Jain-multiverse.16c2401e.png";